import type { TextareaHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export const Textarea = ({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) => (
  <textarea
    className={cn(
      "min-h-24 w-full rounded-md border border-border-strong bg-surface px-3 py-2 text-sm text-text placeholder:text-subtle",
      "focus:border-primary focus:outline-none focus-visible:outline-2 focus-visible:outline-focus",
      "disabled:cursor-not-allowed disabled:bg-surface-muted disabled:text-muted",
      "aria-[invalid=true]:border-danger",
      className,
    )}
    {...props}
  />
);
